module.exports = __webpack_public_path__ + "img/C04-2-CasaBlanca@2x.2ca5519b.png";